module.exports = __webpack_public_path__ + "img/hermiones_yule_ball_dress.f8354312.jpg";